<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { baseUrl } from '@/core/utils'
import { useAbbotDialog, type AbbotDialogProps } from '../../composables/dialog/useAbbotDialog'
import { useAbbotListsAnimate } from '../../composables/animate/useAbbotListsAnimate'
import NameButton from '../button/NameButton.vue'
import { useAbbotDialogWithTimeout } from '../../composables/dialog/useAbbotDialogWithTimeout'

const props = withDefaults(defineProps<AbbotDialogProps>(), {
  autoOpen: false,
})

const { id, lang, detailId, section, showListsSection, showDetailSection, opened, close } = useAbbotDialogWithTimeout(props)
const x = useAbbotListsAnimate(section, detailId)

function imageUrl(file: string) {
  return baseUrl(`/images/abbot/${lang}/${file}`)
}

</script>

<template>
  <transition name="fade">
    <div v-show="opened" ref="abbotRef" :id class="abbot-dialog">
      <!-- lists-section -->
      <transition name="fade">
        <section v-show="section == 'lists'" class="lists-section">
          <img class="title" :src="imageUrl('lists-title.png')" />
          <template v-for="(n, i) in 8">
            <NameButton :data-id="n" :src="imageUrl(`name${n}.png`)" @pointerdown="showDetailSection(n)" />
          </template>
          <img class="close" src="/images/button-close.png" @pointerdown="close" />
        </section>
      </transition>

      <!-- detail-section -->
      <transition name="fade">
        <section v-show="section == 'detail'" class="detail-section">
          <div :class="['detail', `detail${detailId}-${lang}`]">
            <template v-for="(n, i) in 8">
              <img v-show="detailId == n" class="abbot" :src="imageUrl(`abbot${n}.png`)" />
            </template>
            <img class="close" src="/images/button-close.png" @pointerdown="showListsSection" />
          </div>
        </section>
      </transition>
    </div>
  </transition>
</template>

<style scoped>
@import '../../styles/abbot-name-position.css';
@import '../../styles/abbot-detail-position.css';
/* ------------------------ */

/* ------------------------ */
.abbot-dialog {
  position: absolute;
  left: 277px;
  top: 622px;
  width: 700px;
  height: 900px;
  /* border: 1px solid red; */
  /* transform: rotate(90deg); */
}
/* ------------------------ */
.lists-section {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url(/images/abbot/lists-bg.png);
  /* background-image: url(/images/abbot/sample-name-en.jpg); */
}

.lists-section .title {
  position: absolute;
  left: 57px;
  top: 60px;
}

.lists-section .close {
  position: absolute;
  left: 620px;
  top: 45px;
  cursor: pointer;
}
/* ------------------------ */
.detail-section {
  position: absolute;
  top: -106px;
  width: 700px;
  height: 1000px;
  overflow: hidden;
}

.detail-section .detail {
  position: absolute;
}

.detail-section .close {
  position: absolute;
  left: 620px;
  top: 20px;
  cursor: pointer;
}
/* ------------------------ */
</style>
